import { SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";
import { MSFilterLabelSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/label";

type MSFilterTrackRecordSkeletonProps = {
  showIcon?: boolean;
};

export const MSFilterTrackRecordSkeleton = ({
  showIcon,
}: MSFilterTrackRecordSkeletonProps) => {
  const { palette, shadows } = useTheme();

  return (
    <SHStack
      padding={1.5}
      bgcolor={palette.common.white}
      borderRadius={"12px"}
      boxShadow={shadows[1]}
      gap={1.5}
    >
      <MSFilterLabelSkeleton showIcon={showIcon} />
      <SHSkeleton width={"100%"} height={40} delay={false} />
    </SHStack>
  );
};
